<template>
  <v-container
    id="user-profile-view"
    fluid
    tag="section"
  >
    <v-row class="ml-4 mr-4">
      <v-col
        cols="12"
        lg="12"
        md="8"
        sm="6"
      >
        <v-card class="mt-5 pb-4">
          <v-img
            class="rounded-circle elevation-6 mt-n5 ml-n4 d-lg-inline-block"
            :src="$auth.user.picture"
            width="128"
          />
          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                >
                  <v-text-field
                    v-model="name"
                    color="primary"
                    label="Conductor User Name"
                  />
                </v-col>
                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                >
                  <v-text-field
                    readonly
                    color="primary"
                    label="Email Address"
                    :value="$auth.user.email"
                  />
                </v-col>
                <v-divider
                  vertical
                  class="primary"
                />

                <v-col
                  class="ml-4"
                  cols="12"
                  lg="3"
                  md="3"
                >
                  Dark Mode
                  <v-switch
                    v-model="dark"
                    class="ma-0 pa-0"
                    color="primary"
                    hide-details
                    @change="themeChanged"
                  />
                </v-col>
                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                >
                  <v-text-field
                    v-model="firstName"
                    color="primary"
                    label="First Name"
                  />
                </v-col>

                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                >
                  <v-text-field
                    v-model="lastName"
                    color="primary"
                    label="Last Name"
                  />
                </v-col>
                <v-divider
                  vertical
                  class="primary"
                />
                <v-col
                  class="ml-4"
                  cols="12"
                  md="4"
                >
                  Mini Sidebar
                  <v-switch
                    v-model="mini"
                    class="ma-0 pa-0"
                    color="primary"
                    hide-details
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="text-left"
                >
                  <v-btn
                    color="primary"
                    min-width="150"
                    @click="updateButtonClicked"
                  >
                    Update Profile
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <div class="d-flex justify-center">
      <v-alert
        v-model="updateFailed"
        width="400"
        dismissible
        outlined
        prominent
        shaped
        text
        transition="scroll-y-transition"
        icon="mdi-account"
        type="error"
      >
        Failed to Update Profile
      </v-alert>
      <v-alert
        v-model="updatedSucceeded"
        width="400"
        dismissible
        outlined
        prominent
        shaped
        text
        transition="scroll-y-transition"
        icon="mdi-account"
        type="success"
      >
        Profile Updated
      </v-alert>
    </div>
  </v-container>
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { serverUrl } from '../../auth_config.json'

  export default {
    name: 'UserProfileView',
    data () {
      return {
        updatedSucceeded: false,
        updateFailed: false,
      }
    },
    computed: {
      ...sync('app', [
        'mini',
      ]),
      ...sync('user', [
        'dark',
        'name',
        'nickname',
        'firstName',
        'lastName',
      ]),
    },
    watch: {
      updatedSucceeded (visible) {
        if (visible) {
          setTimeout(() => { this.updatedSucceeded = false }, 2000)
        }
      },
      updateFailed (visible) {
        if (visible) {
          setTimeout(() => { this.updateFailed = false }, 2000)
        }
      },
    },
    created () {
    },
    methods: {
      logout () {
        this.$auth.logout()
        this.$router.push({ path: '/' })
      },
      themeChanged () {
        this.$vuetify.theme.isDark = this.dark
      },
      async updateButtonClicked () {
        try {
          const accessToken = await this.$auth.getTokenSilently()

          const res = await fetch(`${serverUrl}/profile/${this.$auth.user.sub}`, {
            method: 'PATCH',
            body: JSON.stringify({
              name: this.name,
              given_name: this.firstName,
              family_name: this.lastName,
              nickname: 'Joe',
              user_metadata: {
                address: '5703 Islington Drive',
                theme: this.dark ? 'dark' : 'light',
                mini: this.mini ? 'true' : 'false',
              },
            }),
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          const data = await res.json()
          this.updatedSucceeded = true
          return data
        } catch (e) {
          this.updateFailed = true
        } finally {
        }
      },
    },
  }
</script>
